<template>
    <div>
        <el-dialog v-model="visible" title="请输入验证码 " :close-on-click-modal="false" :before-close="close" append-to-body>
            <div>
              <div style="margin-bottom:20px;font-size:16px">提示： 你好！{{name}}用户，验证码已经发往您的邮箱{{email}}，若邮箱地址有误，请联系管理员。</div>
              <el-input
                ref="verifiCodeRef"
                v-model="verifyCode"
                :placeholder="t('login.verifyCode')"
                name="verifyCode"
                tabindex="2"
                autocomplete="off"
                @keyup.enter="handleLogin"
              />
            </div>
            <template #footer>
              <span class="dialog-footer">
                <el-button
                  type="primary"
                  @click="handleLogin"
                >确定</el-button>
              </span>
            </template>
        </el-dialog>
    </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { activateAccount } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { resolveLoginRedirectTarget } from '../redirect'
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '111'
    },
    email: {
      type: String,
      default: '2222'
    },
    otherQuery: {
      type: Object
    },
    redirect: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  setup(props, context) {
    const { t } = useI18n()
    const router = useRouter()
    const state = reactive({
      verifyCode: null,
      otherQuery: {},
      name: props.name,
      email: props.email
    })
    const methods = reactive({
      handleLogin() {
        if (!state.verifyCode) {
          ElMessage({
            message: '请填写验证码！',
            type: 'error'
          })
        }
        activateAccount({
          id: props.id,
          verifyCode: state.verifyCode
        }).then(() => {
          router.push({
            path: resolveLoginRedirectTarget(props.redirect, '/'),
            query: props.otherQuery as Record<string, any>
          })
          context.emit('close')
        }).catch((err: any) => {
          console.log(err)
        })
      },
      close() {
        context.emit('close')
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(methods),
      t
    }
  }
})
</script>
